export interface Entity {
  [key: string]: any;
  entityKey: string;
  entityType: string[];
  entityClass: string[] | null | undefined;
  properties: any;
}

export interface EntityClass {
  description: string;
  type: string;
  properties: EntityClassProperty[];
}

export interface EntityClassProperty {
  name: string;
  description: string;
  type: 'array' | 'object' | 'string' | 'boolean' | 'integer' | 'number';
  required: boolean;
  items?: {
    type: 'string';
    enum?: any[];
    format?: 'email';
  };
  examples?: string[];
  source?: string;
  format?: 'email' | 'hostname' | 'uri' | 'ip' | 'ipv4' | 'ipv6' | 'date-time';
}

export interface VertexEntity {
  _id: string;
  _key: string;
  _type?: string[];
  _class?: string[] | null;
  _integrationDefinitionId?: string;
  _integrationInstanceId?: string;
  _integrationName?: string;
  _latest?: boolean;
  _accountId: string;
  displayName: string;
  _createdOn?: string | number | Date;
  _deleted?: boolean;
  _deletedOn?: string | number | Date;
  _endOn?: string | number | Date;
  _beginOn?: string | number | Date;
  _source?: string;
  _version?: number;
}

export interface Vertex {
  id: string;
  properties?: any;
  entity: VertexEntity;
  isPack?: boolean;
}

export enum EntityDescribedPropertyCategory {
  METADATA = 'Metadata',
  TAG = 'Tag',
  PROPERTY = 'Property',
}
export enum EntityDescribedPropertyFormat {
  BOOLEAN = 'Boolean',
  NUMBER = 'Number',
  MARKDOWN = 'Markdown',
  JSON = 'JSON',
  STRING = 'String',
  UNDEFINED = 'Undefined',
  NULL = 'Null',
  UNKNOWN = 'Unknown',
  URI = 'uri',
  EMAIL = 'email',
  IP = 'ip',
  IPV4 = 'ipv4',
  IPV6 = 'ipv6',
  DATETIME = 'datetime',
  UTCDATE = 'utcdate',
  ISODATE = 'isodate',
  DATE = 'date',
  LOCALTIME = 'localtime',
  MONEY = 'money',
}
export interface EntityDescribedProperty {
  name: string;
  description: string;
  required: boolean;
  source: string;
  type: EntityDescribedPropertyFormat | EntityDescribedPropertyFormat[];
  value: any;
  originalValue?: any;
  category: EntityDescribedPropertyCategory;
  edited: boolean;
  isSchemaOnly: boolean;
}

export interface DescribedEntity {
  _id: string;
  _key: string;
  _type: string[];
  _class: string[];
  _source?: string;
  isIntegrationEntity: boolean;
  source: string;
  deleted: boolean;
  deletedOn?: string | number | Date;
  webLink?: string;
  isShodanLink: boolean;
  publicIpAddress?: string;
  properties: EntityDescribedProperty[];
  displayName: string;
}

export type DeletedProperty = Pick<
  EntityDescribedProperty,
  'originalValue' | 'name' | 'category'
>;
